import React from "react";

const SectionHeader = ({ eyebrow, title, description, action }) => (
  <div className="page-title-row">
    <div>
      {eyebrow && <p className="eyebrow" style={{ marginBottom: 4 }}>{eyebrow}</p>}
      <h2 style={{ margin: 0 }}>{title}</h2>
      {description && (
        <p style={{ margin: "6px 0 0", fontSize: "0.875rem", color: "var(--text-muted)" }}>
          {description}
        </p>
      )}
    </div>
    {action && <div style={{ flexShrink: 0 }}>{action}</div>}
  </div>
);

export default SectionHeader;
